import React, {useEffect} from "react";
import styled from "styled-components";
import {Button, Col, Collapse, DatePicker, Form, Image, List, Modal, Pagination, Row, Space} from "antd";
import {DownOutlined, RedoOutlined, SearchOutlined, UpOutlined} from "@ant-design/icons";
import Input from "antd/es/input/Input";
import {useStore} from "../../store";
import {observer} from "mobx-react";
import "../../css/table.css";
import "../../css/global.css"
import "../../css/table-scroll-x.css"
import LibraryDetail from "./library-detail";
import {getImageInfo} from "../../http/manager";
import {ImageInfoEntity} from "../../entity/image-info-entity";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {BaseImageUrl} from "../../http/http";

const LibraryList: React.FC = () => {

    const [form] = Form.useForm();
    const store = useStore();
    const {homeLibrary} = store;
    useEffect(() => {
        getLibraryList({})
        return clear();
    }, []);

    const clear = () => {
        homeLibrary.clear()
    }

    const getLibraryList = (params: any) => {
        showFullScreenLoading()
        getImageInfo(params)
            .then((res) => {
                tryHideFullScreenLoading()
                homeLibrary.pagination.total = res.data ? res.data.total : 0
                refreshDataSource(res.data ? res.data.list : []);
            })
            .catch(() => {
                tryHideFullScreenLoading()
            })
    }

    const refreshDataSource = (data: ImageInfoEntity[]) => {
        const list: ImageInfoEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        homeLibrary.setDataSource(list);
    }

    const onExpendClick = () => {
        const fields = form.getFieldsValue;
        const isExpend = homeLibrary.isExpend;
        homeLibrary.setExpend(!isExpend);
        form.setFieldsValue(fields);
    }

    const onRest = () => {
        homeLibrary.resetQuery();
        form.setFieldsValue(homeLibrary.condition);
        onQuery()
    }

    const FirstLevelSearch = () => {
        return (
            <Form form={form} labelAlign={"right"} style={{maxWidth: "none"}} wrapperCol={{span: "15"}}><Row>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"libraryCode"}
                                                    label={"物种名"}><Input/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"specimenName"}
                                                    label={"物种拉丁名"}><Input/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"gatherDate"}
                                                    label={"科名"}><Input/></Form.Item></Col>
                <Col span={3}><Button onClick={onExpendClick}
                                      icon={homeLibrary.isExpend ? <UpOutlined/> : <DownOutlined/>}
                                      type={"link"}>{homeLibrary.isExpend ? "折叠" : "展开"}</Button></Col>
            </Row></Form>)
    }

    const SecondLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth: "none"}} wrapperCol={{span: "15"}}><Row>
            <Col span={6} offset={1}><Form.Item name={"gatherer"} labelCol={{span: "7"}} label={"种拉丁名"}><Input
            /></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"takeTime"} labelCol={{span: "7"}}
                                                label={"拍摄时间"}><DatePicker format={"YYYY-MM-DD"}/></Form.Item></Col>
            <Col span={6} offset={1}/>
            <Col span={3}/>
        </Row></Form>)
    }

    const toDetail = (item: any, index: number) => {
        homeLibrary.setDetail(item);
        homeLibrary.setIndex(index);
        homeLibrary.setDetailModalOpen(true);
    }

    const onClose = () => {
        homeLibrary.setDetailModalOpen(false);
    }

    const onSizeChange = (page: any, pageSize: any) => {
        homeLibrary.pagination.pageSize = pageSize;
        homeLibrary.pagination.pageNum = page;
        onQuery();
    }

    const onQuery = () => {
        const params = {
            cnName: form.getFieldValue("libraryCode"),
            ldName: form.getFieldValue("specimenName"),
            specCnName: form.getFieldValue("gatherDate"),
            genLdName: form.getFieldValue("gatherer"),
            createtime: form.getFieldValue("takeTime") ? form.getFieldValue("takeTime").format("YYYY-MM-DD") : "",
            pageNum: homeLibrary.pagination.pageNum,
            pageSize: homeLibrary.pagination.pageSize,
        }
        getLibraryList(params);
    }

    const renderItem = (item: ImageInfoEntity, index: number) => {
        return <List.Item style={{minWidth: "400px"}}>
            <CardWrapper onClick={() => toDetail(item, index)}>
                <div style={{display: "flex", flexDirection: "row", padding: "5px 20px 10px 5px"}}>
                    {/*<img*/}
                    {/*    style={{width: "150px", height: "150px", margin: "15px 20px 10px 15px", pointerEvents: "none"}}*/}
                    {/*    src={item.imgUrl ? BaseImageUrl + item.imgUrl : ""}/>*/}
                    <Image style={{width:"150px", height:"150px", margin:"15px 20px 10px 15px"}} src={BaseImageUrl+item.imgUrl} preview={false}/>
                    <CardContent>
                        <span>{`物种名:${item.cnName}`}</span>
                        <span>{`物种拉丁名：${item.ldName}`}</span>
                        <span>{`科名：${item.specCnName}`}</span>
                        <span>{`种拉丁名：${item.genLdName}`}</span>
                        <span>{`拍摄时间：${item.createtime}`}</span>
                    </CardContent>
                </div>
            </CardWrapper>
        </List.Item>
    }
    return (<Wrapper>
        <SearchWrapper>
            <SearchTitleWrapper>
                <div className={"searchTitle"}>查询区域</div>
                <Space className={"searchButton"} size={"small"} align={"start"} direction={"horizontal"}>
                    <Button icon={<SearchOutlined/>} onClick={onQuery} type={"primary"}>查询</Button>
                    <Button icon={<RedoOutlined/>} onClick={onRest} ghost={true} type={"primary"}>重置</Button>
                </Space>
            </SearchTitleWrapper>
            <Line/>
            <Collapse
                style={{margin: "0", padding: "0"}}
                activeKey={homeLibrary.isExpend ? ['1'] : ["0"]}
                defaultActiveKey={['0']} ghost>
                <Collapse.Panel collapsible={"icon"} showArrow={false} key={1} header={<FirstLevelSearch/>}>
                    <SecondLevelSearch/>
                </Collapse.Panel>
            </Collapse>
        </SearchWrapper>
        <ContentWrapper>
            <div
                style={{
                    margin: "15px 79px",
                    height: "400px",
                    marginBottom: "30px",
                    overflowY: "auto",
                    overflowX: "hidden"
                }}>
                <List grid={{
                    gutter: 16,
                    column: 3
                }} style={{overflow: "scroll"}} dataSource={homeLibrary.dataSource} renderItem={renderItem}/>
            </div>
            <Pagination
                size={"small"}
                style={{margin: "0 20px 20px 0", alignSelf: "end"}}
                total={homeLibrary.pagination.total}
                showQuickJumper={true}
                showSizeChanger={true}
                defaultPageSize={10}
                hideOnSinglePage={true}
                onChange={onSizeChange}
                current={homeLibrary.pagination.pageNum}
            />
        </ContentWrapper>
        <Modal
            open={homeLibrary.detailModalOpen}
            onCancel={onClose}
            closable={true}
            centered={true}
            destroyOnClose={true}
            title={null}
            footer={null}
            mask={true}
            maskClosable={true}
            width={"1000px"}>
            <LibraryDetail detail={homeLibrary.detailEntity} index={homeLibrary.index}/>
        </Modal>
    </Wrapper>);
}

export default observer(LibraryList);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: hidden;

    .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
      padding: 12px 16px 12px 12px;
    }

    .ant-list {
      overflow-x: hidden;
    }
  }
`;

const CardWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E8EBF2;
    border-radius: 2px;
  }
`;

const CardContent = styled.span`
  & {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;

    span:nth-child(1) {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: black;
      margin-bottom: 10px;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const SearchTitleWrapper = styled.div`
  & {
    display: flex;
    flex-direction: row;
    margin: 15px 20px 13px 20px;

    .searchTitle {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      flex: 1;
    }
  }
`;

const Line = styled.div`
  & {
    height: 0.5px;
    border: 1px solid #EAEDF7;
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 0 20px 20px 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;

    .ant-list {
      overflow-x: hidden;
    }
  }
`;
